<script>
export default {
  props: ['item'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div>
    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> MLS details :</h5>
    <div class="row"> 
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: 1}, {name: 'No', value: 0}]" Title="Live :" Definition="Live status means the MLS is accessible on the client website for visitors to submit new listings." Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" Title="MLS name :" v-model="item.title" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" Title="Office name :" v-model="item.office_name"></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="MLS logo URL :" v-model="item.mls_logo"></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="Textarea" Title="MLS disclaimer :" v-model="item.mls_disclaimer"></w-field>
      </div>
    </div>

    <h5 class="section-header mb-3 mt-5"><Icon icon="ri:book-2-line"></Icon> IDX details :</h5>
    <div class="row">
      <div class="col-sm-12">
        <w-field SimpleDataType="String List, Single" Title="IDX type :" :Options="[{name: 'None', value: 'None'},{name: 'RETS', value: 'rets'},{name: 'Bridge API', value: 'bridge_api'},{name: 'MLS Grid', value: 'mls_grid'}]" v-model="item.idx_type" Required></w-field>
      </div>
    </div>
    <div v-if="item.idx_type == 'RETS'" class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="RETS login url :" v-model="item.idx_rets_url" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="RETS username :" v-model="item.idx_rets_username" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="RETS username :" v-model="item.idx_rets_password" Required></w-field>
      </div>
    </div>
    <div v-if="item.idx_type == 'Bridge API'" class="row">
      <div class="col-sm-6">
        <w-field SimpleDataType="String" Title="Bridge key :" v-model="item.idx_bridge_key" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" Title="Bridge dataset ID :" v-model="item.idx_bridge_dataset_id" Required></w-field>
      </div>
    </div>

    <h5 class="section-header mb-3 mt-5"><Icon icon="ri:book-2-line"></Icon> Back office details :</h5>
    <div class="row">
      <div class="col-sm-12">
        <w-field SimpleDataType="String List, Single" Title="Back office type :" :Options="[{name: 'None', value: 'None'},{name: 'RETS', value: 'rets'},{name: 'Bridge API', value: 'bridge_api'},{name: 'MLS Grid', value: 'mls_grid'}]" v-model="item.back_office_type" Required></w-field>
      </div>
    </div>
    <div v-if="item.back_office_type == 'RETS'" class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="RETS login url :" v-model="item.back_office_rets_url" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="RETS username :" v-model="item.back_office_rets_username" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="RETS password :" v-model="item.back_office_rets_password" Required></w-field>
      </div>
    </div>
    <div v-if="item.back_office_type == 'Bridge API'" class="row">
      <div class="col-sm-6">
        <w-field SimpleDataType="String" Title="Bridge key :" v-model="item.back_office_bridge_key" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" Title="Bridge dataset ID :" v-model="item.back_office_bridge_dataset_id" Required></w-field>
      </div>
    </div>

    <h5 v-if="item.idx_type != 'None' || item.back_office_type != 'None'" class="section-header mb-3 mt-5"><Icon icon="ri:book-2-line"></Icon> Replication details :</h5>
    <div v-if="item.idx_type != 'None' || item.back_office_type != 'None'" class="row">
      <div v-if="item.idx_type == 'Bridge API' || item.back_office_type == 'Bridge API'" class="col-sm-6">
        <w-field SimpleDataType="String" Title="Bridge office ID :" v-model="item.bridge_office_id"></w-field>
      </div>
      <div v-if="item.idx_type == 'RETS' || item.back_office_type == 'RETS'" class="col-sm-6">
        <w-field SimpleDataType="String" Title="RETS office ID :" v-model="item.rets_office_id"></w-field>
      </div>
      <div v-if="item.idx_type == 'RETS' || item.back_office_type == 'RETS'" class="col-sm-12 mb-2">
        <label>RETS field class(s) :</label>
        <div v-for="(field, field_i) in item.rets_property_types" :key="field_i" class="input-group mb-1">
          <input type="text" placeholder="Feed class" class="form-control" v-model="field.id" required>
          <div class="input-group-append">
            <multiselect v-model="field.type" :options="['Single Family','Multiple Dwelling','Land or Lot']" placeholder="Dwelling type" required></multiselect>
          </div>
          <div class="input-group-append"><button type="button" class="btn btn-white" @click="item.rets_property_types.splice(field_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button></div>
        </div>
        <div><button type="button" class="btn btn-sm btn-primary mb-1" @click="item.rets_property_types.push({id:'',type:''})"><Icon icon="ri:add-line" height="18"></Icon> Add</button></div>
      </div>
    </div>
    <div v-if="item.idx_type != 'None' || item.back_office_type != 'None'" class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Last IDX date :" v-model="item.last_idx"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Last clean date :" v-model="item.last_clean"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Last back office date :" v-model="item.last_bo"></w-field>
      </div>
      <div class="col-sm-12 text-muted small">
        Current UTC datetime : {{moment.utc().format()}}
      </div>
    </div>
    <div class="clearfix mt-3"></div>

  </div>
</template>
